import WaitingComponent from './waiting_component';

export default WaitingComponent;
